module.exports = __webpack_public_path__ + "images/marketing_site/screenshot4.png";